import jp from 'jsonpath'

export default {
  applications() {
    return {
      "backEnd": {
        "url": '', // localtest: http://localhost:8584  // localtoProd: "http://localhost:3000" // Prod: ""
        "timeout": 500
      },
      "frontend": {
        "version": "0.0.6"
      }

    };
  },
  getStatuList() {
    return {
      "status": [
        { name: "Active", key: "ACTV" },
        { name: "Deleted", key: "DEL" },
      ]
    };
  },
  getCategories() {
    return {
      "roles": [
     
      ]
    };
  },
  getDayName(day) {
    var days = ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'];
    return days[day];
  },
  getMonthName(m) {
    var months = ['', 'Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];
    return months[m];
  },

  menus() {
    return {
      "__v": 0,
      "name": "senfoni-doc",
      "url": "senfonidocURL",
      "logoDesc": "",
      "_id": "59b8edd0bedbaa1f00f303d8",
      "menus": [
        {
          "cap": "Ana Sayfa",
          "icon": "fa fa-home",
          "click": "#",
          "param": false
        },
        {
          "cap": "Pricing",
          "icon": "fa fa-home",
          "click": "#",
          "param": false
        },
        {
          "cap": "Features",
          "icon": "fa fa-home",
          "click": "#",
          "param": false
        }, {
          "cap": "About",
          "icon": "fa fa-home",
          "click": "#",
          "param": false
        },
      ]
    };
  },
  getExp(obj, exp) {
    var ret = "-";
    try {
      ret = jp.query(obj, exp)[0];
    }
    catch (err) {
    }
    return ret;
  },
  getRoles() {
    return { "roles": ["simple", "develeoper", "designer", "tester", "operation", "admin"] };
  },
  getStandartCommnets() {
    return { "comments": ["appropriate", "denied", "need reevaluation"] };
  },
  getPageVals() {
    return {
      "pages": [
        { "link": "templates", "cap": "Templates" },
        { "link": "profile", "cap": "Profile" },
        { "link": "agreements", "cap": "Agreements" },
        { "link": "main", "cap": "Main" },
        { "link": "verify", "cap": "Verify" },
        { "link": "new", "cap": "Send New" },
        { "link": "org", "cap": "Organization" }


      ]
    };
  },

  encode64(input) {
    var keyStr = "ABCDEFGHIJKLMNOP" +
      "QRSTUVWXYZabcdef" +
      "ghijklmnopqrstuv" +
      "wxyz0123456789+/" +
      "=";
    input = escape(input);
    var output = "";
    var chr1, chr2, chr3 = "";
    var enc1, enc2, enc3, enc4 = "";
    var i = 0;

    do {
      chr1 = input.charCodeAt(i++);
      chr2 = input.charCodeAt(i++);
      chr3 = input.charCodeAt(i++);

      enc1 = chr1 >> 2;
      enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
      enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
      enc4 = chr3 & 63;

      if (isNaN(chr2)) {
        enc3 = enc4 = 64;
      } else if (isNaN(chr3)) {
        enc4 = 64;
      }

      output = output +
        keyStr.charAt(enc1) +
        keyStr.charAt(enc2) +
        keyStr.charAt(enc3) +
        keyStr.charAt(enc4);
      chr1 = chr2 = chr3 = "";
      enc1 = enc2 = enc3 = enc4 = "";
    } while (i < input.length);

    return output;
  },
  decode64(input) {
    var keyStr = "ABCDEFGHIJKLMNOP" +
      "QRSTUVWXYZabcdef" +
      "ghijklmnopqrstuv" +
      "wxyz0123456789+/" +
      "=";
    var output = "";
    var chr1, chr2, chr3 = "";
    var enc1, enc2, enc3, enc4 = "";
    var i = 0;

    // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
    var base64test = /[^A-Za-z0-9\+\/\=]/g;
    if (base64test.exec(input)) {
      return "failed";
    }
    if (!input)
      return;
    do {
      enc1 = keyStr.indexOf(input.charAt(i++));
      enc2 = keyStr.indexOf(input.charAt(i++));
      enc3 = keyStr.indexOf(input.charAt(i++));
      enc4 = keyStr.indexOf(input.charAt(i++));

      chr1 = (enc1 << 2) | (enc2 >> 4);
      chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
      chr3 = ((enc3 & 3) << 6) | enc4;

      output = output + String.fromCharCode(chr1);

      if (enc3 != 64) {
        output = output + String.fromCharCode(chr2);
      }
      if (enc4 != 64) {
        output = output + String.fromCharCode(chr3);
      }

      chr1 = chr2 = chr3 = "";
      enc1 = enc2 = enc3 = enc4 = "";

    } while (i < input.length);

    return unescape(output);
  },
  getTheDateStr(today, iii) {
    //today.setHours(today.getHours() +3);
    today.setDate(today.getDate() + iii);
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }

    today = yyyy + '-' + mm + '-' + dd;
    return today;
  },
  getTheDateFullStr(today, iii) {
    //today.setHours(today.getHours() +3);
    today.setDate(today.getDate() + iii);
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();
    var hh = today.getHours();
    var min = today.getMinutes();
    var sec = today.getHours();

    if (dd < 10) {
      dd = '0' + dd;
    }

    if (mm < 10) {
      mm = '0' + mm;
    }

    if (hh < 10) {
      hh = '0' + hh;
    }

    if (min < 10) {
      min = '0' + min;
    }

    if (sec < 10) {
      sec = '0' + sec;
    }

    today = yyyy + '-' + mm + '-' + dd + 'T' + hh + ':' + min + ":" + sec;
    //console.log("tx:" + today);
    return today;
  },
  getTheDateStrDMY(today, iii) {
    //today.setHours(today.getHours() +3);
    today = new Date(today);
    today.setDate(today.getDate() + iii);
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();


    if (dd < 10) {
      dd = '0' + dd;
    }

    if (mm < 10) {
      mm = '0' + mm;
    }



    today = dd + '.' + mm + '.' + yyyy;
    //console.log("t:" + today);
    return today;
  },
  convertDateFromISOtoDMY(dated) {
    var d = new Date(dated);
    d.setHours(d.getHours() + 3);
    dated = d.toISOString();
    try {
      var ret = "";

      ret = dated.substring(8, 10) + "." + dated.substring(5, 7) + "." + dated.substring(0, 4);

      return ret;
    } catch (eer) {
      return dated;
    }

  },
  addTimeZoneToDate(today) {
    var d = new Date(today);
    d.setHours(d.getHours() + 3);
    return d;
  },
  convertDateFromISOtoDMYwithHMS(dated) {
    var d = new Date(dated);
    d.setHours(d.getHours() + 3);
    dated = d.toISOString();
    try {
      var ret = "";

      ret = dated.substring(8, 10) + "." + dated.substring(5, 7) + "." + dated.substring(0, 4) + " " + dated.substring(11, 13) + ":" + dated.substring(14, 16) + ":" + dated.substring(17, 19);;

      return ret;
    } catch (eer) {
      return dated;
    }

  },
  getTodaysDate() {
    //today.setHours(today.getHours() +3);
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();


    if (dd < 10) {
      dd = '0' + dd;
    }

    if (mm < 10) {
      mm = '0' + mm;
    }



    today = dd + '.' + mm + '.' + yyyy;
    //console.log("t:" + today);
    return today;

  },
  detectBrowser() {


    if ((!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0) return "Opera";

    if (typeof InstallTrigger !== 'undefined') return "Firefox";

    if (/constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification))) return "Safari";

    if (/*@cc_on!@*/false || !!document.documentMode) return "IE";

    if (!!window.StyleMedia) return "Edge";

    if (!!window.chrome && !!window.chrome.webstore) return "Chrome";

    return "Browser";
  }
  ///New methods here


};


// WEBPACK FOOTER //
// ./src/config/Defaults.js